export default __webpack_public_path__ + "static/media/180919 - Ferraillage radier E5.f6540b80.jpg";